// extracted by mini-css-extract-plugin
export default {"textBlockWrapper":"LandscapeTextBlockOrganism_textBlockWrapper__pSK+0","button":"LandscapeTextBlockOrganism_button__2ZDXs"};